// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 获取消息推送列表
export function getProjectConfigList(data) {
  const url = global.requestUrl + '/projectConfig/list'
  return axios.get(url)
}
